export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const RESET_SHIPPING_COST = "RESET_SHIPPING_COST";
export const CREATE_SHIPPING_COST = "CREATE_SHIPPING_COST";
export const UPDATE_SHIPPING_COST = "UPDATE_SHIPPING_COST";
export const FETCH_SHIPPING_COSTS = "FETCH_SHIPPING_COSTS";
export const FETCH_SHIPPING_COST = "FETCH_SHIPPING_COST";
export const DELETE_SHIPPING_COST = "DELETE_SHIPPING_COST";
